import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useLang } from "@/i18n";

export default function WorkspaceBreadcrumb({ currentLabel, testid }) {
  const { tf } = useLang();
  return (
    <div className="flex items-center gap-1 text-xs">
      <Link to="/dashboard" data-testid={testid}
        className="inline-flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors">
        <ChevronLeft className="h-3.5 w-3.5" /> {tf("Dashboard")}
      </Link>
      <span className="text-muted-foreground/50">›</span>
      <span className="text-foreground/70">{tf(currentLabel)}</span>
    </div>
  );
}
